module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow@3x-a01f53e721226b949307d0572f9cd6c5.png";